export type StoreSyncPart = 'merchant' | 'menu' | 'legal_terms'

export type StoreSyncPartStatus = {
  needsSync: boolean
  isSyncing: boolean
  lastSyncedAt: string | null
  syncRequestedAt: string | null
  errorMessage: string | null
}

export const STORE_SYNC_TIMEOUT_ERROR = 'sync_timeout'

export type StoreSyncStatus = {
  syncing: boolean
  needsSync: boolean
  parts: Record<StoreSyncPart, StoreSyncPartStatus>
  activeBatch: StoreSyncPart[] | null
}

export type StoreSyncModalPhase = 'review' | 'syncing' | 'success' | 'error'

export type StoreSyncStepState = 'pending' | 'active' | 'done' | 'failed'

export const STORE_SYNC_PARTS: StoreSyncPart[] = ['merchant', 'menu', 'legal_terms']
